import SelectDropdown from "../../components/searchSelect";
import AnnualReport from "./AnnualReport";
import { BackButtonWrap, ContentWrapper, DescriptionItem, DescriptionWrapper, DownArrowIcon, FlexContainer, HeaderContainer, HeaderTitleWrap, TabItem, TableContainer, Tabs, TabWrapper, WrapperContainer } from "./Innerpage.style"
import {useEffect, useState} from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import useHttp from "../../axios/useHttp";
import endpoints from "../../axios/endPoints";
import LoadingEffect from "../../components/LoadingEffect";
import languageList from '../../assets/language/language.json';
import { toast } from "react-toastify";

const MildacInnerPage = () => {
    const navigate = useNavigate();
    const {region, productCode} = useParams();
    const [searchParams] = useSearchParams();
    const language = searchParams.get("lang") || 'en';
    const [activeTab, setActiveTab] = useState("first")
    const [loading, setLoading] = useState(false);
    const [chartLoading, setChartLoading] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);
    const { get } = useHttp();
    const [labels, setLabelList] = useState([]);
    const [dataSet, setDataSet] = useState([]);
    const [fundDetails, setFundDetails] = useState();
    const [version, setVersion] = useState([]);
    const [scenarioData, setScenarioData] = useState();
    const [isPIC, setIsPIC] = useState(false);
    const [performanceHistory, setPerformanceHistory] = useState(0);
    const [languages, setLanguage] = useState(null)
    const [performanceOptions, setPerformanceOptions] = useState([]);

    useEffect(() => {
        if(languageList[language]){
            setLanguage(languageList[language])
        } else {
            setLanguage(languageList['en'])
        }

    }, [language])

    const getPastPerformanceData = async(mil_fund_code) => {
        setChartLoading(true)
        try {
            const response = await get({endpoint: `${endpoints.mildac.getPastPerformance}/${mil_fund_code}` });
            setDataSet(response?.data?.map(el => el.value || 0));
            setLabelList(response?.data?.map(el => el.year));
            setChartLoading(false)
        } catch (err) {
            setChartLoading(false)
            if(err?.status === 400)
                toast.error(err?.response?.data?.message || "Something went wrong. Please try again later.")
            else {
                toast.error("Something went wrong. Please try again later.")
            }
        }
    }

    const [noData, setNoData] = useState(false);
    useEffect(()=> {
        if(dataSet.length) {
            setNoData(dataSet.every((value) => value == null || value === 0))
            const firstNonZeroIndex = dataSet.findIndex(item => item !== 0);
            setPerformanceHistory(firstNonZeroIndex === -1 ? 0 : dataSet.length - firstNonZeroIndex);
        }
        else {
            setNoData(true);
            setPerformanceHistory(0);
        }
    },[dataSet])
    
    const getPastPerformanceOptions = async() => {
        setLoading(true)
        try {
            const response = await get({endpoint: `${endpoints.mildac.getPastPerformanceOptions}/${productCode}` });
            // setPerformanceOptions(response?.fund_details || []);
            const updatedData = response?.fund_details?.map(el=> 
                ({...el, investKey: `${el.investment_option_code} - ${el.investment_option_name}`}))
                setPerformanceOptions(updatedData || []);
            setDataSet((response?.data||[])?.map(el => el.value || 0));
            setLabelList(response?.data?.map(el => el.year));
            setFundDetails({...response.fund_details[0]});
            setLoading(false)
            if(response.fund_details?.length)
                getPastScenarioDates(response.fund_details[0]?.mil_kid_product_code, response.fund_details[0]?.investment_option_code);
        } catch (err) {
            setLoading(false)
        }
    }

    const [selectedVersion, setSelectedVersion] = useState(true)
    
    const translateLabels = (data) => {
        return data.map(item => {
          const [monthName, year] = item.label.split(" ");
          const translatedMonth = languages?.[monthName.toLowerCase()] || monthName;
          return {
            ...item,
            label: `${translatedMonth} ${year}`
          };
        });
    }
    const getPastScenarioDates = async(product_code, investment_option_code) => {
        // setLoading(true)
        setSelectedVersion(false);
        try {
            const response = await get({endpoint: `${endpoints.mildac.getPastPerformanceDates}${product_code}/${investment_option_code}` });
            setVersion(translateLabels(response.dates) || [])
            setSelectedVersion(true);
            setScenarioData(response.latest_data||{})
            setIsPIC((response.latest_data?.example_investment_amount||0)>=10000)
            setLoading(false)
        } catch (err) {
            setLoading(false)
        }
    }
    
    const getPastScenarioTable = async(option) => {
        try {
            setTableLoading(true);
            const response = await get({endpoint: `${endpoints.mildac.getPastPerformanceScenario}${fundDetails?.mil_kid_product_code}/${fundDetails?.investment_option_code}/${option.year}/${option.month}` });
            setScenarioData(response.data||{})
            setIsPIC((response.data?.example_investment_amount||0)>=10000)
            setTableLoading(false)
        } catch (err) {
            console.log(err)
            setTableLoading(false)
        }
    }
    const formatAmount = (amount) => {
        return Number(amount)?.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        })
    }
    const formatPcnt = (value) => {
        return (Number(value)*100)?.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        }) + '%'
    }
    const toTitleCase = (str) => {
        return str?.toLowerCase().replace(/\b\w/g, char => char?.toUpperCase());
    }
    useEffect(()=> {
        if(productCode) {
            getPastPerformanceOptions();
        }
    }, [productCode])
    return <>
        <FlexContainer justify={'center'} width={'100%'}>
            <WrapperContainer maxwidth={'1440px'}>
                <HeaderContainer>
                    <BackButtonWrap onClick={()=>navigate(`/mildac/${region}/products?lang=${language}`)}>
                        <DownArrowIcon
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="none"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <polyline points="6 9 12 15 18 9"></polyline>
                        </DownArrowIcon>
                        <span>{languages?.back_product}</span>
                    </BackButtonWrap>
                    <HeaderTitleWrap>
                        <h1>{fundDetails?.product_name}</h1>
                    </HeaderTitleWrap>
                    
                    {loading ? <LoadingEffect width={'50%'} height={'60px'}/> : <SelectDropdown options={performanceOptions} 
                        styles={{margin: '0 16px'}}
                        width={'520px'}
                        listplacement={'bottom'}
                        placeholder={languages?.investment_option}
                        searchenabled={true}
                        searchKey={'investKey'}
                        displayKey={'investKey'}
                        onSelect={(e)=> {
                            setFundDetails({...e});
                            getPastPerformanceData(e.fund_code);
                            getPastScenarioDates(e.mil_kid_product_code, e.investment_option_code);
                        }}
                        defaultSelection={true}/>}
                  <hr></hr>
                  <TabWrapper>
                    <Tabs>
                        <TabItem onClick={()=> setActiveTab('first')} className={`${activeTab === 'first' ? 'active' : ''}`}>{languages?.past_performance}</TabItem>
                        {version.length ? 
                        <TabItem onClick={()=> setActiveTab('second')} className={`${activeTab === 'second' ? 'active' : ''}`}>PRIIPS {languages?.performance_scenarios}</TabItem> : null}
                    </Tabs>
                  </TabWrapper>
                </HeaderContainer>
                <ContentWrapper>
                    {activeTab === 'first' ? fundDetails && Object.keys(fundDetails).length ? <>
                        <DescriptionWrapper margin={'0 16px'}>
                        {loading || chartLoading ? <LoadingEffect width={'50%'} height={'60px'}/> : performanceHistory > 1 && !noData? 
                        <DescriptionItem className={'full-width font-bold'}>
                            <span>{languages.chart_top_text.replace('[x]', performanceHistory > 10 ? 10 : performanceHistory )}</span>
                            </DescriptionItem> : 
                            null}
                        </DescriptionWrapper>
                        {loading || chartLoading ? <LoadingEffect width={'50%'} height={'300px'} margin={'2% 0 0'}/> :
                        <AnnualReport chartHeight={'400px'} chartWidth={'100%'}
                        dataSet={dataSet} labels={labels}
                        noDataText={performanceHistory < 1 || noData ? languages?.one_year_text?.replace('[Share Class launch date: DD Month YYYY]', fundDetails?.launch_date) : ''}
                        bottomtext={(region === 'italy' ? languages?.below_graph_italy : languages?.below_graph)?.replace('[Share class name]', `${fundDetails?.investment_option_code} - ${fundDetails?.investment_option_name}`)?.replace("[DD Month YYYY]", fundDetails?.launch_date)}
                        />}
                        { performanceHistory > 1 && !noData ? <DescriptionWrapper>
                            {/* <DescriptionItem className={'font-bold'}>
                            <span>{languages?.past_text_one}</span>
                            </DescriptionItem> */}
                            <DescriptionItem className={'font-bold full-width'}>
                            <span>{languages?.past_text_two}</span>
                            </DescriptionItem>
                        </DescriptionWrapper> : null}
                    </> : <DescriptionWrapper>
                            <DescriptionItem className={'font-bold'}>
                            <span>{languages?.no_data}</span>
                            </DescriptionItem></DescriptionWrapper> :
                    <>
                        <DescriptionWrapper margin={'0 32px'}>
                            <DescriptionItem className={'full-width'}>
                            <span>{scenarioData?.priips_bootstrap_category === 'CAT 3 WIP' ? languages?.cat_3_text : languages?.rhp_text?.replace('[RHP + 5]', scenarioData?.recommended_holding_period+5)}
                            </span>
                            </DescriptionItem>
                        </DescriptionWrapper>
                        <SelectDropdown 
                        options={version} 
                        styles={{margin: '32px'}}
                        width={'520px'}
                        placeholder={languages?.version}
                        searchKey={'label'}
                        displayKey={'label'}
                        onSelect={(e)=> {getPastScenarioTable(e)}} 
                        defaultSelection={selectedVersion}/>
                        {!tableLoading && <TableContainer>
                            <table>
                                <thead>
                                    <tr>
                                        <th style={{fontSize: '14px'}} colSpan={5}>{(isPIC?languages?.recommended_pic:languages?.recommended_pac)?.replace('[year]', scenarioData?.recommended_holding_period || 0).replace('[amount]', scenarioData?.example_investment_amount || 0)}</th>
                                    </tr>
                                    <tr>
                                        <th style={{fontSize: '14px'}} colSpan={5}>{languages?.insurance_prem}</th>
                                    </tr>
                                    <tr>
                                        <th>{languages?.scenarios}</th>
                                        <th></th>
                                        <th width={'100px'}>{languages?.exit_text} 1 {languages?.year}</th>
                                        {scenarioData?.half_recommended_holding_period && <th width={'100px'}>{languages?.exit_text} {scenarioData?.half_recommended_holding_period} {languages?.years}</th>}
                                        {scenarioData?.recommended_holding_period && <th width={'100px'}>{languages?.exit_text} {scenarioData?.recommended_holding_period} {languages?.years}</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th className="bold" colSpan={5}>{languages?.survival_scenarios}</th>
                                    </tr>
                                    <tr>
                                        <th className="bold">{languages?.min_scenario}</th>
                                        {/* <td className="bold">{languages?.no_min_guarantee}</td> */}
                                        <td colSpan={4} className="bold">{languages?.min_guaran}</td>
                                    </tr>
                                    <tr>
                                        <th className="bold">{languages?.stress_scenario}</th>
                                        <td className="bold">{languages?.get_back}</td>
                                        <td className="bold">€ {formatAmount(scenarioData.return_stress_val_1y)}</td>
                                        {scenarioData?.half_recommended_holding_period && <td className="bold">€ {formatAmount(scenarioData.return_stress_val_half_rhp)}</td>}
                                        {scenarioData?.recommended_holding_period && <td className="bold">€ {formatAmount(scenarioData.return_stress_val_rhp)}</td>}
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <td>{languages?.average_return}</td>
                                        <td>{`${formatPcnt(scenarioData.return_stress_pcnt_1y)}`}</td>
                                        {scenarioData?.half_recommended_holding_period && <td>{`${formatPcnt(scenarioData.return_stress_pcnt_half_rhp)}`}</td>}
                                        {scenarioData?.recommended_holding_period && <td>{`${formatPcnt(scenarioData.return_stress_pcnt_rhp)}`}</td>}
                                    </tr>
                                    <tr>
                                        <th className="bold">{languages?.unfav_scenario}</th>
                                        <td className="bold">{languages?.get_back}</td>
                                        <td className="bold">€ {formatAmount(scenarioData.return_unfavourable_val_1y)}</td>
                                        {scenarioData?.half_recommended_holding_period && <td className="bold">€ {formatAmount(scenarioData.return_unfavourable_val_half_rhp)}</td>}
                                        {scenarioData?.recommended_holding_period && <td className="bold">€ {formatAmount(scenarioData.return_unfavourable_val_rhp)}</td>}
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <td>{languages?.average_return}</td>
                                        <td>{`${formatPcnt(scenarioData.return_unfavourable_pcnt_1y)}`}</td>
                                        {scenarioData?.half_recommended_holding_period && <td>{`${formatPcnt(scenarioData.return_unfavourable_pcnt_half_rhp)}`}</td>}
                                        {scenarioData?.recommended_holding_period && <td>{`${formatPcnt(scenarioData.return_unfavourable_pcnt_rhp)}`}</td>}
                                    </tr>
                                    <tr>
                                        <th className="bold">{languages?.mod_scenario}</th>
                                        <td className="bold">{languages?.get_back}</td>
                                        <td className="bold">€ {formatAmount(scenarioData.return_moderate_val_1y)}</td>
                                        {scenarioData?.half_recommended_holding_period && <td className="bold">€ {formatAmount(scenarioData.return_moderate_val_half_rhp)}</td>}
                                        {scenarioData?.recommended_holding_period && <td className="bold">€ {formatAmount(scenarioData.return_moderate_val_rhp)}</td>}
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <td>{languages?.average_return}</td>
                                        <td>{`${formatPcnt(scenarioData.return_moderate_pcnt_1y)}`}</td>
                                        {scenarioData?.half_recommended_holding_period && <td>{`${formatPcnt(scenarioData.return_moderate_pcnt_half_rhp)}`}</td>}
                                        {scenarioData?.recommended_holding_period && <td>{`${formatPcnt(scenarioData.return_moderate_pcnt_rhp)}`}</td>}
                                    </tr>
                                    <tr>
                                        <th className="bold">{languages?.fav_scenario}</th>
                                        <td className="bold">{languages?.get_back}</td>
                                        <td className="bold">€ {formatAmount(scenarioData.return_favourable_val_1y)}</td>
                                        {scenarioData?.half_recommended_holding_period && <td className="bold">€ {formatAmount(scenarioData.return_favourable_val_half_rhp)}</td>}
                                        {scenarioData?.recommended_holding_period && <td className="bold">€ {formatAmount(scenarioData.return_favourable_val_rhp)}</td>}
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <td>{languages?.average_return}</td>
                                        <td>{`${formatPcnt(scenarioData.return_favourable_pcnt_1y)}`}</td>
                                        {scenarioData?.half_recommended_holding_period && <td>{`${formatPcnt(scenarioData.return_favourable_pcnt_half_rhp)}`}</td>}
                                        {scenarioData?.recommended_holding_period && <td>{`${formatPcnt(scenarioData.return_favourable_pcnt_rhp)}`}</td>}
                                    </tr>
                                    <tr>
                                        <th className="bold" colSpan={2}>{languages?.invest}</th>
                                        <td className="bold">€ {formatAmount(scenarioData.example_investment_amount) || 0}</td>
                                        {scenarioData?.half_recommended_holding_period && <td className="bold">€ {formatAmount(scenarioData?.half_recommended_holding_period/(isPIC?scenarioData?.half_recommended_holding_period:1) * scenarioData.example_investment_amount)}</td>}
                                        {scenarioData?.recommended_holding_period && <td className="bold">€ {formatAmount(scenarioData?.recommended_holding_period/(isPIC?scenarioData?.recommended_holding_period:1) * scenarioData.example_investment_amount)}</td>}
                                    </tr>
                                    <tr>
                                        <th className="bold" colSpan={5}>{languages?.death}</th>
                                    </tr>
                                    <tr>
                                        <th>{languages?.event}</th>
                                        <td className="bold">{languages?.benef}</td>
                                        <td className="bold">€ {formatAmount(scenarioData.insured_event_return_val_1y) || 0}</td>
                                        {scenarioData?.half_recommended_holding_period && <td className="bold">€ {formatAmount(scenarioData.insured_event_return_val_half_rhp)}</td>}
                                        {scenarioData?.recommended_holding_period && <td className="bold">€ {formatAmount(scenarioData.insured_event_return_val_rhp)}</td>}
                                    </tr>
                                    <tr>
                                        <th colSpan={2}>{languages.insure_prem}</th>
                                        <td className="bold">€ 0</td>
                                        {scenarioData?.half_recommended_holding_period && <td className="bold">€ 0</td>}
                                        {scenarioData?.recommended_holding_period && <td className="bold">€ 0</td>}
                                    </tr>
                                </tbody>
                            </table>
                        </TableContainer>}
                    </>}
                </ContentWrapper>
            </WrapperContainer>
        </FlexContainer>
    </>;
}

export default MildacInnerPage;